import { useEffect, useRef, useState } from 'react';
import { MotionConfig } from 'framer-motion';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import { Header, Footer } from './components/SiteChrome';
import { Hero } from './components/Hero';
import { Services, About, Marquee } from './components/Sections';
import { ServiceModal } from './components/ServiceModal';
import { Cursor } from './components/Motion';
import './App.css';

export default function App() {
  const [site, setSite] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const [selected, setSelected] = useState(null);
  const returnFocus = useRef(null);
  const lenis = useRef(null);

  useEffect(() => {
    const controller = new AbortController();
    setError(false);
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site`, { signal: controller.signal })
      .then(response => { if (!response.ok) throw new Error('Content unavailable'); return response.json(); })
      .then(setSite)
      .catch(err => { if (err.name !== 'AbortError') setError(true); });
    return () => controller.abort();
  }, [attempt]);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const scroll = new Lenis({ autoRaf: true, duration: 1.15, anchors: { offset: -88 }, smoothWheel: true });
    lenis.current = scroll;
    return () => { scroll.destroy(); lenis.current = null; };
  }, []);

  useEffect(() => {
    if (selected) lenis.current?.stop();
    else lenis.current?.start();
  }, [selected]);

  const openService = service => {
    returnFocus.current = document.activeElement;
    setSelected(service);
  };

  return (
    <MotionConfig reducedMotion="user">
      <a className="skip-link" href="#sadrzaj" data-testid="skip-to-content">Preskoči na sadržaj</a>
      <Header />
      <main id="sadrzaj" data-testid="main-content">
        <Hero />
        <Services services={site?.services} error={error} retry={() => setAttempt(n => n + 1)} onSelect={openService} />
        <Marquee />
        <About />
      </main>
      <Footer company={site?.company} services={site?.services || []} onSelect={openService} />
      <ServiceModal service={selected} onClose={() => setSelected(null)} returnFocus={returnFocus} />
      <Cursor />
    </MotionConfig>
  );
}